import { Flex, UnstyledButton } from "@sidelinesports/fan-design-system";
import { useQuery } from "@tanstack/react-query";
import type { ComponentProps } from "react";
import { getAppConfig } from "../../../../api";
import { UploadedImage } from "../../../../components";
import styles from "./MenuTriggerButton.module.css";

export const MenuTriggerButton = ({
  onClick,
  ...props
}: Omit<ComponentProps<typeof UnstyledButton>, "children">) => (
  <UnstyledButton
    className={styles["menu-trigger-button"]}
    type="button"
    onClick={onClick}
    {...props}
  >
    <div className={styles["shaded-circle"]} />
    <div className={styles["logo-box"]}>
      <TeamLogo />
    </div>
    <Flex direction="column" gap={4}>
      <div className={styles.triangle} style={{ transform: "rotate(90deg)" }} />
    </Flex>
  </UnstyledButton>
);

const TeamLogo = () => {
  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: getAppConfig,
  });

  const teamLogo = configQuery.data?.team?.logo ?? null;

  return (
    <UploadedImage
      image={teamLogo}
      alt=""
      tracking={{
        enabled: true,
        location: "MenuTriggerButton::TeamLogo",
      }}
    />
  );
};
